import { useEffect, useState } from 'react'
import {
  SkeletonLoader,
  SKELETON_LOADER_VARIANT_ONWHITE,
  Text,
  TEXT_VARIANT_LIGHT,
  LINK_VARIANT_EXTRALIGHT,
  IconFAExclamationTriangle,
  ICON_FA_VARIANT_SOLID,
  Link
} from 'mailup-web-components'
import { useRecoilCallback } from 'recoil'
import { getCampaignSourceByIdCallback } from '../recoil/callbacks/callbacks'
import { evalCondition } from 'mailup-react-helpers'
import { useIntl } from 'react-intl'
import { CONTENT_SOURCE_UPDATE_STATUS_KO } from 'Constants/'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'

export const StyledIconWarningTriangle = styled(IconFAExclamationTriangle)`
  color: ${(props) => props.color};
  font-size: 16px;
  margin-right: 8px;
`

const ContentSource = ({ IdSource }) => {
  const isSourceEnabled = evalCondition('uo:CONTENTSSOURCES')
  const intl = useIntl()
  const history = useHistory()
  const [contentSource, setContentSource] = useState({
    sourceName: '',
    itemLength: 0,
    isEnabled: false,
    sourceType: '',
    status: '',
    error: false,
    loaded: false
  })

  const getCampaignSourceById = useRecoilCallback(
    getCampaignSourceByIdCallback,
    []
  )

  useEffect(() => {
    if (IdSource > 0) {
      getCampaignSourceById(IdSource).then((e) => {
        if (e.error) {
          setContentSource((prev) => ({
            ...prev,
            error: e.error,
            loaded: true
          }))
        } else {
          setContentSource((prev) => ({
            ...prev,
            sourceName: e.source ? e.source.SourceName : '-',
            itemLength:
              e.listOfStatus && e.listOfStatus.length > 0
                ? e.listOfStatus.Items.length
                : 0,
            isEnabled: e.source ? e.source.IsEnabled : false,
            sourceType: e.source ? e.source.SourceType : 0,
            status:
              e.listOfStatus && e.listOfStatus.length > 0
                ? e.listOfStatus.Items[0].Status
                : 0,
            loaded: true
          }))
        }
      })
    }
  }, [IdSource])

  const getIcon = () => {
    let icon
    if (contentSource.itemLength > 0) {
      if (!contentSource.isEnabled) {
        icon = (
          <StyledIconWarningTriangle
            variant={ICON_FA_VARIANT_SOLID}
            color='#CBCBCB'
          />
        )
      } else {
        if (contentSource.status === CONTENT_SOURCE_UPDATE_STATUS_KO) {
          icon = (
            <StyledIconWarningTriangle
              variant={ICON_FA_VARIANT_SOLID}
              color='#FA4747'
            />
          )
        }
      }
    }
    return icon
  }

  const getIconText = () => {
    let iconTextOrLink
    if (contentSource.itemLength > 0) {
      if (!contentSource.isEnabled) {
        if (isSourceEnabled) {
          iconTextOrLink = (
            <Link
              variant={LINK_VARIANT_EXTRALIGHT}
              onClick={() => {
                history.push(
                  `/automation/source/${contentSource.sourceType}/${IdSource}`
                )
              }}
            >
              {intl.formatMessage({
                id: 'Load.ContentsCampaignList.UpdatdateSourceStop'
              })}
            </Link>
          )
        } else {
          iconTextOrLink = (
            <Text variant={TEXT_VARIANT_LIGHT}>
              {intl.formatMessage({
                id: 'Load.ContentsCampaignList.UpdatdateSourceStop'
              })}
            </Text>
          )
        }
      } else {
        if (contentSource.status === CONTENT_SOURCE_UPDATE_STATUS_KO) {
          if (isSourceEnabled) {
            iconTextOrLink = (
              <Link
                variant={LINK_VARIANT_EXTRALIGHT}
                onClick={() => {
                  history.push(
                    `/automation/source/${contentSource.sourceType}/${IdSource}`
                  )
                }}
              >
                {intl.formatMessage({
                  id: 'Load.ContentsCampaignList.UpdatdateSourceError'
                })}
              </Link>
            )
          } else {
            iconTextOrLink = (
              <Text variant={TEXT_VARIANT_LIGHT}>
                {intl.formatMessage({
                  id: 'Load.ContentsCampaignList.UpdatdateSourceError'
                })}
              </Text>
            )
          }
        }
      }
    }
    return iconTextOrLink
  }

  return (
    <>
      {contentSource.loaded && !contentSource.error && (
        <>
          <Text variant={TEXT_VARIANT_LIGHT}>
            {intl.formatMessage({ id: 'Load.MailupCommon.Id' }) +
              ' ' +
              IdSource +
              ' - ' +
              contentSource.sourceName}
          </Text>
          {getIcon()} {getIconText()}
        </>
      )}

      {contentSource.loaded && contentSource.error && (
        <>
          <Text variant={TEXT_VARIANT_LIGHT}>-</Text>
        </>
      )}

      {!contentSource.loaded && !contentSource.error && (
        <SkeletonLoader variant={SKELETON_LOADER_VARIANT_ONWHITE} />
      )}
    </>
  )
}

ContentSource.propTypes = {
  IdSource: PropTypes.any
}

export default ContentSource
